import { render, staticRenderFns } from "./SessionDocuments.vue?vue&type=template&id=4df9e2d4&scoped=true&"
import script from "./SessionDocuments.vue?vue&type=script&lang=js&"
export * from "./SessionDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SessionDocuments.vue?vue&type=style&index=0&id=4df9e2d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df9e2d4",
  null
  
)

export default component.exports